// ============================================================================
// Wizard answer shape — shared across step components, the wizard shell, and
// the `buildWizardActions` resolver. The wizard collects answers progressively;
// each field is null until the user picks an option.
// ============================================================================

export type TrafficSource = 'direct' | 'shopify' | 'woocommerce' | 'landing';

export type CheckoutStyle = 'classic' | 'bogo';

export type OfferStrategy = 'none' | 'single' | 'geo' | 'split';

export type PaymentMode = 'standard' | 'manual';

export interface QuickstartAnswers {
    trafficSource: TrafficSource | null;
    checkoutStyle: CheckoutStyle | null;
    offerStrategy: OfferStrategy | null;
    /** ISO 3166-1 alpha-2 codes, only meaningful when offerStrategy === 'geo'. */
    geoCountries: string[];
    paymentMode: PaymentMode | null;
    /** Manual payment methods to surface in the checkout, filtered down to
     *  whatever the store actually has configured. Only relevant when
     *  paymentMode === 'manual'. Possible values: 'zelle', 'custom-payment'. */
    manualPaymentMethods: string[];
    /** Q5 — add a VIP club page (gated on the store having an active club).
     *  When true, the wizard adds a standalone funnel step mounted at the
     *  `club` mount point and powered by tagada-native. */
    wantsClub: boolean | null;
    /** Q6 — add a subscription management portal page. When true, the
     *  wizard adds a standalone funnel step mounted at the `portal` mount
     *  point and powered by tagada-native. */
    wantsPortal: boolean | null;
}

export const EMPTY_ANSWERS: QuickstartAnswers = {
    trafficSource: null,
    checkoutStyle: null,
    offerStrategy: null,
    geoCountries: [],
    paymentMode: null,
    manualPaymentMethods: [],
    wantsClub: null,
    wantsPortal: null,
};

export type WizardStepIndex = 1 | 2 | 3 | 4 | 5 | 6;
